module.exports = __webpack_public_path__ + "static/media/daniela.42894c44.png";